import {
  IConnectBtcResponse,
  IInjectedBtcProvider,
  TNetworkMode,
} from '../../types';
import { getInjectedOkxBtcProvider } from './getInjectedBtcProvider';

// https://www.okx.com/web3/build/docs/sdks/chains/bitcoin/provider#accountchanged
const OKX_ACCOUNT_CHANGE_EVENT = 'accountChanged';

/**
 * Connect to the OKX wallet.
 *
 * @param networkMode - The network mode.
 *
 * @returns Standard response with the address and public key.
 */
export async function connectOKX(
  networkMode: TNetworkMode,
): Promise<IConnectBtcResponse> {
  const provider = getInjectedOkxBtcProvider(networkMode);
  const response = await provider.connect();

  const injectedProvider: IInjectedBtcProvider = {
    onAccountChange: (callback: (args: any) => void) => {
      provider.on(OKX_ACCOUNT_CHANGE_EVENT, callback);
    },
    removeAccountChangeListener: (callback: (args: any) => void) => {
      provider.off(OKX_ACCOUNT_CHANGE_EVENT, callback);
    },
  };

  return {
    address: response.address,
    publicKey: response.publicKey,
    injectedProvider,
  };
}
